import { Button, FormGroup, Slider, Switch } from '@blueprintjs/core';
import { observer } from 'mobx-react-lite';
import { useAppModel } from '@/models/AppModel';

/** Both settings entry points edit the same live, browser-wide preference. */
export const SoundSettings = observer(function SoundSettings() {
  const appModel = useAppModel();
  const userPreferences = appModel.userPreferencesModel;
  return (
    <div>
      <Switch
        label="Sound effects"
        checked={userPreferences.soundConfig.enabled}
        onChange={(event) =>
          userPreferences.setSoundConfig({
            enabled: event.currentTarget.checked,
          })
        }
      />
      <FormGroup
        label={`Volume: ${Math.round(userPreferences.soundConfig.volume * 100)}%`}
      >
        <Slider
          min={0}
          max={100}
          stepSize={1}
          labelStepSize={25}
          handleHtmlProps={{ 'aria-label': 'Sound effects volume' }}
          disabled={!userPreferences.soundConfig.enabled}
          value={Math.round(userPreferences.soundConfig.volume * 100)}
          onChange={(value) => userPreferences.setSoundConfig({ volume: value / 100 })}
        />
      </FormGroup>
      <Button
        disabled={
          !userPreferences.soundConfig.enabled || userPreferences.soundConfig.volume === 0
        }
        onClick={(event) => {
          event.stopPropagation();
          appModel.playSound('place');
        }}
      >
        Test sound
      </Button>
    </div>
  );
});
